import active from "./active";
import adelphic from "./adelphic";
import adroll from "./adroll";
import affiliates from "./affiliates";
import amazon from "./amazon";
import applovin from "./applovin";
import attentive from "./attentive";
import avant from "./avant";
import awin from "./awin";
import backInStock from "./back-in-stock";
import blisspointMedia from "./blisspoint-media";
import cloudflare from "./cloudflare";
import cnn5things from "./cnn-5-things";
import criteo from "./criteo";
import dianomi from "./dianomi";
import email from "./email";
import facebook from "./facebook";
import friendbuy from "./friendbuy";
import geistM from "./geist-m";
import georgias from "./georgias";
import globalE from "./global-e";
import goDaddy from "./go-daddy";
import google from "./google";
import googleDomains from "./google-domains";
import grin from "./grin";
import hyros from "./hyros";
import impactRadius from "./impact-radius";
import influencers from "./influencers";
import instagram from "./instagram";
import iterable from "./iterable";
import klaviyo from "./klaviyo";
import linkTree from "./link-tree";
import linkedIn from "./linked-in";
import linkinBio from "./linkin-bio";
import liveintent from "./liveintent";
import loox from "./loox";
import mediaGo from "./media-go";
import mediamath from "./mediamath";
import meta from "./meta";
import microsoft from "./microsoft";
import mntn from "./mntn";
import naver from "./naver";
import neonPixel from "./neon-pixel";
import newsbreak from "./newsbreak";
import nextdoor from "./nextdoor";
import northbeam from "./northbeam";
import organicSearch from "./organic-search";
import outbrain from "./outbrain";
import partnerize from "./partnerize";
import paypal from "./paypal";
import pebblePost from "./pebble-post";
import pepperjam from "./pepperjam";
import pinterest from "./pinterest";
import postscript from "./postscript";
import preset from "./preset";
import pushOwl from "./push-owl";
import rakuten from "./rakuten";
import reSci from "./re-sci";
import recart from "./recart";
import recharge from "./recharge";
import reddit from "./reddit";
import refersion from "./refersion";
import retentionScience from "./retention-science";
import revContent from "./rev-content";
import rockerbox from "./rockerbox";
import s2s from "./s2s";
import sendgrid from "./sendgrid";
import sezzle from "./sezzle";
import shareASale from "./share-a-sale";
import shopify from "./shopify";
import smileRewards from "./smile-rewards";
import sms from "./sms";
import snapchat from "./snapchat";
import snowball from "./snowball";
import sourceKnowledge from "./source-knowledge";
import spotify from "./spotify";
import stackAdapt from "./stack-adapt";
import stripe from "./stripe";
import taboola from "./taboola";
import talkable from "./talkable";
import tapjoy from "./tapjoy";
import tatari from "./tatari";
import tikTok from "./tik-tok";
import tradedesk from "./tradedesk";
import tripleWhale from "./triple-whale";
import tv from "./tv";
import twitch from "./twitch";
import twitter from "./twitter";
import unattributed from "./unattributed";
import veDigital from "./ve-digital";
import wickedreports from "./wickedreports";
import woo from "./woo";
import wunderkind from "./wunderkind";
import yahoo from "./yahoo";
import yotpo from "./yotpo";
import youTube from "./you-tube";

export const PLATFORMS = {
  active,
  adelphic,
  adroll,
  affiliates,
  amazon,
  attentive,
  avant,
  awin,
  backInStock,
  blisspointMedia,
  cloudflare,
  cnn5things,
  criteo,
  dianomi,
  email,
  facebook,
  friendbuy,
  geistM,
  georgias,
  globalE,
  goDaddy,
  google,
  googleDomains,
  grin,
  hyros,
  impactRadius,
  influencers,
  instagram,
  iterable,
  klaviyo,
  linkedIn,
  linkinBio,
  linkTree,
  liveintent,
  loox,
  mediaGo,
  mediamath,
  meta,
  microsoft,
  mntn,
  naver,
  neonPixel,
  newsbreak,
  nextdoor,
  northbeam,
  organicSearch,
  outbrain,
  partnerize,
  paypal,
  pebblePost,
  pepperjam,
  pinterest,
  postscript,
  preset,
  pushOwl,
  rakuten,
  recart,
  recharge,
  reddit,
  refersion,
  reSci,
  retentionScience,
  revContent,
  rockerbox,
  s2s,
  sendgrid,
  sezzle,
  shareASale,
  shopify,
  smileRewards,
  sms,
  snapchat,
  snowball,
  sourceKnowledge,
  spotify,
  stackAdapt,
  stripe,
  taboola,
  talkable,
  tapjoy,
  tatari,
  tikTok,
  tradedesk,
  tripleWhale,
  tv,
  twitch,
  twitter,
  unattributed,
  veDigital,
  wickedreports,
  woo,
  wunderkind,
  yahoo,
  yotpo,
  youTube,
  applovin,
};
